import axiosInstance from "@/lib/axios";

export const orderService = {
  // Pour les administrateurs - récupérer toutes les commandes
  getAdminOrders: async ({ page = 1, status = null, user_id = null, shop_id = null, payment_method = null, payment_status = null, date_from = null, date_to = null, per_page = 15 }) => {
    let url = `/api/v1/admin/orders?page=${page}&per_page=${per_page}`;
    
    if (status) url += `&status=${status}`;
    if (user_id) url += `&user_id=${user_id}`;
    if (shop_id) url += `&shop_id=${shop_id}`;
    if (payment_method) url += `&payment_method=${payment_method}`;
    if (payment_status) url += `&payment_status=${payment_status}`;
    if (date_from) url += `&date_from=${date_from}`;
    if (date_to) url += `&date_to=${date_to}`;
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  // Pour les utilisateurs normaux - voir leurs commandes
  getUserOrders: async ({ page = 1, status = null }) => {
    let url = `/api/v1/user/orders?page=${page}`;
    if (status) url += `&status=${status}`;
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  // Voir une commande spécifique (admin)
  getOrderDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/orders/${id}`);
    return response.data;
  },
  
  // Voir une commande spécifique (utilisateur)
  getUserOrderDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/user/orders/${id}`);
    return response.data;
  },
  
  // Créer une nouvelle commande
  createOrder: async (orderData) => {
    const response = await axiosInstance.post('/api/v1/user/orders', orderData);
    return response.data;
  },
  
  // Annuler une commande (utilisateur)
  cancelOrder: async (id) => {
    const response = await axiosInstance.post(`/api/v1/user/orders/${id}/cancel`);
    return response.data;
  },
  
  // Confirmer un paiement
  confirmPayment: async (orderId, transactionId) => {
    const response = await axiosInstance.post(`/api/v1/user/orders/${orderId}/confirm-payment`, {
      transaction_id: transactionId
    });
    return response.data;
  },
  
  // Pour les propriétaires de boutique - voir les commandes de leur boutique
  getShopOrders: async ({ page = 1, status = null, date_from = null, date_to = null }) => {
    let url = `/api/v1/shop/orders?page=${page}`;
    
    if (status) url += `&status=${status}`;
    if (date_from) url += `&date_from=${date_from}`;
    if (date_to) url += `&date_to=${date_to}`;
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  // Pour les administrateurs - voir les commandes d'une boutique spécifique
  getAdminShopOrders: async ({ shop_id, page = 1, status = null, date_from = null, date_to = null }) => {
    if (!shop_id) throw new Error("L'ID de la boutique est requis");
    
    let url = `/api/v1/admin/shop/${shop_id}/orders?page=${page}`;
    
    if (status) url += `&status=${status}`;
    if (date_from) url += `&date_from=${date_from}`;
    if (date_to) url += `&date_to=${date_to}`;
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  // Mettre à jour le statut d'une commande (admin)
  updateOrderStatus: async (id, status) => {
    const response = await axiosInstance.put(`/api/v1/admin/orders/${id}/status`, {
      status
    });
    return response.data;
  },
  
  // Mettre à jour le statut de paiement d'une commande (admin)
  updatePaymentStatus: async (id, paymentData) => {
    const response = await axiosInstance.put(`/api/v1/admin/orders/${id}/payment-status`, paymentData);
    return response.data;
  },
  
  // Obtenir les statistiques des commandes globales (admin)
  getOrderStatistics: async (shopId = null) => {
    let url = '/api/v1/admin/statistics/orders';
    if (shopId) {
      url += `?shop_id=${shopId}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  // Obtenir les statistiques des commandes d'une boutique (shop owner)
  getShopOrderStatistics: async () => {
    const response = await axiosInstance.get('/api/v1/shop/orders/statistics');
    return response.data;
  },
  
  // Obtenir l'historique d'une commande (admin)
  getOrderHistory: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/orders/${id}/history`);
    return response.data;
  },
  
  // Exporter les commandes (fonctionnalité admin)
  exportOrders: async (filters = {}) => {
    let url = '/api/v1/admin/orders/export';
    const queryParams = new URLSearchParams(filters).toString();
    if (queryParams) {
      url += `?${queryParams}`;
    }
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  }
};

export default orderService;